import { render, staticRenderFns } from "./FIBQuizFlowHeader.vue?vue&type=template&id=60b06cd7&scoped=true&"
import script from "./FIBQuizFlowHeader.vue?vue&type=script&lang=js&"
export * from "./FIBQuizFlowHeader.vue?vue&type=script&lang=js&"
import style0 from "./FIBQuizFlowHeader.vue?vue&type=style&index=0&id=60b06cd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b06cd7",
  null
  
)

export default component.exports